import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ImpressumComponent implements OnInit {

  constructor( private titleService: Title
  ) {
      this.titleService.setTitle('Alexander Koenig - Impressum');
  }

  ngOnInit() {
  }

}
